import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServerListComponent } from './main/server/server-list/server-list.component';
import { AuthGuard } from './auth/auth-guard.service';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/main/servers' },
  { path: 'main', loadChildren: './main/main.module#MainModule', canActivate: [AuthGuard] },
  { path: '**', component: ServerListComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
